import { dbPost } from '../../apis/commonApi';

class BasicSurveyFirstController {
  constructor(
    { store, updateStore },
    { pageParam, setPageParam },
    { taskInfo, setTaskInfo },
    { saveParam, setSaveParam },
    modalService,
    validateService,
    navigate
  ) {
    this.store = store;
    this.updateStore = updateStore;
    this.pageParam = pageParam;
    this.setPageParam = setPageParam;
    this.taskInfo = taskInfo;
    this.setTaskInfo = setTaskInfo;
    this.saveParam = saveParam;
    this.setSaveParam = setSaveParam;
    this.modalService = modalService;
    this.validateService = validateService;
    this.navigate = navigate;
  }

  async fnSearch() {
    const url = '/aia/analysis/bsc/first/list.do';

    let response;

    try {
      response = await dbPost(url, {
        entSn: this.pageParam?.entSn,
        aiaAplyId: this.pageParam?.aiaAplyId,
        anlsAplyId: this.pageParam?.aiaAplyId,
      });

      if (response instanceof Error) {
        this.modalService.errorAlert('처리중 에러가 발생하였습니다.', () => {});
      } else {

        this.setTaskInfo(response?.taskInfo);

        if (response?.taskBsc !== null) {
          this.setSaveParam({ ...response?.taskBsc, mode: 'ex' });
        } else {
          this.setSaveParam({ ...response?.taskInfo, mode: 'new' });
        }
      }
    } catch (e) {
      this.modalService.errorAlert('처리중 에러가 발생하였습니다.', () => {});
    }
  }

  async fnSave() {
    const url = '/aia/analysis/bsc/first/save.do';
    const param = {
      mode: this.pageParam?.flag,
      entSn: this.pageParam?.entSn,
      aiaAplyId: this.pageParam?.aiaAplyId,
      anlsAplyId: this.pageParam?.aiaAplyId,
      ...this.saveParam,
    };

    let response;

    try {
      response = await dbPost(url, param);

      if (response instanceof Error) {
        this.modalService.errorAlert('처리중 에러가 발생하였습니다.', () => {});
      } else {
        this.navigate('/ai/basicSurveySecond', {
          state: {
            entSn: this.pageParam?.entSn,
            aiaAplyId: this.pageParam?.aiaAplyId,
            anlsAplyId: this.pageParam?.aiaAplyId,
            anlsRsltId: this.taskInfo?.anlsRsltId,
            bscExmnId: response?.bscExmnId,
          },
        });
      }
    } catch (e) {
      this.modalService.errorAlert('처리중 에러가 발생하였습니다.', () => {});
    }
  }

  async saveParamChange(model, value) {
    if (model === 'eqpmntFlctnYn') {
      this.setSaveParam({
        ...this.saveParam,
        eqpmntFlctnYn: value,
        eqpmntFlctnPrd: '',
        eqpmntFlctnUnit: '',
        eqpmntFlctnEtcMttr: '',
      });
    } else if (model === 'taskQtyFlctnYn') {
      this.setSaveParam({
        ...this.saveParam,
        taskQtyFlctnYn: value,
        taskQtyFlctnPrd: '',
        taskQtyFlctnUnit: '',
        taskQtyFlctnMttr: '',
      });
    } else if (model === 'spdFlctnYn') {
      this.setSaveParam({
        ...this.saveParam,
        spdFlctnYn: value,
        spdFlctnPrd: '',
        spdFlctnUnit: '',
        spdFlctnEtcMttr: '',
      });
    } else if (model === 'bizFlctnYn') {
      this.setSaveParam({
        ...this.saveParam,
        bizFlctnYn: value,
        bizFlctnPrd: '',
        bizFlctnUnit: '',
        bizFlctnEtcMttr: '',
      });
    } else {
      this.setSaveParam({ ...this.saveParam, [model]: value });
    }
  }
}

export default BasicSurveyFirstController;
